import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-grid">
        <div className="footer-brand">
          <h3>VEKTRIXO <span className="logo-accent">DIGITAL</span></h3>
          <p>Next-gen engineering, design, and business strategy from the heart of Pune.</p>
        </div>

        <div className="footer-links">
          <h4>Services</h4>
          <ul>
            <li>Web Development</li>
            <li>QA & Testing</li>
            <li>Graphic Design</li>
            <li>Business Consulting</li>
          </ul>
        </div>

        <div className="footer-links">
          <h4>Company</h4>
          <ul>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/careers">Careers</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
          </ul>
        </div>

        <div className="footer-links">
          <h4>Our Platforms</h4>
          <ul>
            <li>
              <a href="https://auditorpro.vektrixo.com" target="_blank" rel="noopener noreferrer">
                AuditorPro (SEO Audit)
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <p>© 2026 Vektrixo Digital. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;